import { useTheme } from "@emotion/react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetTitlesCall } from "../../redux/api/title.api";

function Titles({ type }) {
  const slideType = type;
  const three_d_model = type === "three_d_model";
  // const type = "his";
  const initialItems = useSelector((state) => state?.title?.titles);
  const lang = useSelector((state) => state.general?.lang ?? "en");
  const redux = useSelector((state) => state);
  console.log("pippo redux", redux);
  const [fileRefs, setFileRefs] = useState({}); // store refs by subtitle ID

  const [items, setItems] = useState(initialItems);
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [message, setMessage] = useState("");
  // const [lang, setLanguage] = useState("en");

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);
  const dispatch = useDispatch();
  const theme = useTheme();

  const navigate = useNavigate();
  const fetchTitles = async () => {
    await GetTitlesCall(lang, type);
  };

  useEffect(() => {
    fetchTitles();
  }, [type, lang]);

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  const handleLanguageChange = (event) => {
    // setLanguage(event.target.value);
    dispatch(setLang(event.target.value));
  };

  const handleSeeMaterial = async (item) => {
    const id = item?.slides?.[0]?.id;
    if (id) {
      navigate(`/showThreeD/${id}/${lang}`);
      if (!three_d_model) {
        navigate(`/showTitle/${id}/${lang}`);
      } else {
        navigate(`/showThreeD/${id}/${lang}`);
      }
    }
  };

  const renderItem = (item, index) => {
    const filteredTitle = item?.titleLocalizations?.filter(
      (e) => e.field == "title"
    );

    const title = filteredTitle?.[0]?.value || "Click to edit the title";
    const url = require("../../assets/images/no-image.jpg");
    return (
      <MDBox
        p={2}
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        borderRadius="8px"
      >
        <MDTypography
          variant="h6"
          style={{
            cursor: "pointer",
            textAlign: "center",
            fontSize: "1.4rem",
            fontWeight: 700,
          }}
        >
          {title}
        </MDTypography>

        {item?.subtitles?.length > 0 && (
          <MDBox
            display="grid"
            gridTemplateColumns={{
              xs: "repeat(1, 1fr)", // mobile
              sm: "repeat(2, 1fr)", // small
              md: "repeat(3, 1fr)", // medium
              lg: "repeat(5, 1fr)", // large
            }}
            gap={4}
            mt={2}
          >
            {item.subtitles.map((subtitle) => {
              const filteredTitle = subtitle?.titleLocalizations?.filter(
                (e) => e.field == "title"
              );
              const title =
                filteredTitle?.[0]?.value || "Click to edit the sub title";
              const url = require("../../assets/images/no-image.jpg");

              return (
                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: 8,
                    minWidth: 200, // prevents tiles from being too small
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)", // added shadow
                    transition: "transform 0.2s, box-shadow 0.2s", // smooth hover effect
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 16px rgba(0, 0, 0, 0.25)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 8px rgba(0, 0, 0, 0.15)";
                  }}
                  onClick={() => handleSeeMaterial(subtitle)}
                >
                  <MDBox
                    key={subtitle.id}
                    p={2}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <img
                      src={
                        subtitle?.image ??
                        (isEmpty(subtitle?.slides?.[0]?.Files?.[0]?.url)
                          ? url
                          : subtitle?.slides?.[0]?.Files?.[0]?.url +
                            "/3/3/3.png")
                      }
                      alt={title}
                      style={{
                        width: "100%",
                        maxWidth: 200, // optional, max tile width
                        height: "auto",
                        borderRadius: "8px",
                        marginBottom: "10px",
                      }}
                    />
                    <MDTypography
                      variant="h6"
                      style={{
                        cursor: "pointer",
                        textAlign: "center",
                        fontSize: "1rem",
                        fontWeight: 400,
                      }}
                    >
                      {title}
                    </MDTypography>
                  </MDBox>
                </div>
              );
            })}
          </MDBox>
        )}
      </MDBox>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1} display="flex" justifyContent="flex-end" mb={2}>
        <Grid container spacing={2} alignItems="center">
          {/* Add Title Button on the Left */}

          {/* Language Dropdown on the Right */}
          <Grid
            item
            xs
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            {/* <FormControl style={{ width: 250 }}>
              <InputLabel>Language</InputLabel>
              <Select
                value={lang}
                onChange={handleLanguageChange}
                style={{ height: 50 }}
              >
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="fr">French</MenuItem>
                <MenuItem value="ko">Korean</MenuItem>
                <MenuItem value="pt">Portuguese (Portugal)</MenuItem>
                <MenuItem value="pt-br">Portuguese (Brazil)</MenuItem>
                <MenuItem value="es">Spanish</MenuItem>
                <MenuItem value="it">Italian</MenuItem>
                <MenuItem value="ge">German</MenuItem>
                <MenuItem value="nl">Dutch</MenuItem>
                <MenuItem value="zh-cn">Chinese (Simplified)</MenuItem>
                <MenuItem value="zh-tw">Chinese (Traditional)</MenuItem>
                <MenuItem value="ja">Japanese</MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
                <MenuItem value="kk">Kazakh</MenuItem>
                <MenuItem value="tk">Turkmen</MenuItem>
                <MenuItem value="tr">Turkish</MenuItem>
                <MenuItem value="fa">Persian (Farsi)</MenuItem>
                <MenuItem value="hi">Hindi</MenuItem>
                <MenuItem value="id">Indonesian</MenuItem>
                <MenuItem value="ro">Romanian</MenuItem>
                <MenuItem value="ru">Russian</MenuItem>
                <MenuItem value="vi">Vietnamese</MenuItem>
                <MenuItem value="ms">Malay</MenuItem>
                <MenuItem value="tl">Tagalog (Filipino)</MenuItem>
                <MenuItem value="no">Norwegian</MenuItem>
                <MenuItem value="da">Danish</MenuItem>
                <MenuItem value="sv">Swedish</MenuItem>
                <MenuItem value="el">Greek</MenuItem>
                <MenuItem value="pl">Polish</MenuItem>
                <MenuItem value="cs">Czech</MenuItem>
                <MenuItem value="fi">Finnish</MenuItem>
                <MenuItem value="hu">Hungarian</MenuItem>
              </Select>
            </FormControl> */}
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={1}>
        <Grid container spacing={3}>
          {!isEmpty(items) &&
            items.map((item, index) => (
              <Grid item xs={12} key={item.id}>
                {renderItem(item, index)}
              </Grid>
            ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Titles;
